export default (props, vars) =>
  props?.['applicationOffer']?.['job_type'] === 'pr'
    ? `Congratulations!\nYou're officially part of the Practicum!`
    : `Congratulations!\nYou're officially an Extern!`;
